if (!customElements.get('featured-collection-tabs')) {
  class FeaturedCollectionTabs extends HTMLElement {
    connectedCallback() {
      // Also handles markup inserted by the section's lazy content loader.
      this.connectFrame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.connectFrame);
      cancelAnimationFrame(this.refreshFrame);
      this.events?.abort();
    }

    initialize() {
      this.events?.abort();
      this.events = new AbortController();

      this.tabs = Array.from(
        this.querySelectorAll('[data-collection-tab]')
      );

      this.panels = Array.from(
        this.querySelectorAll('[data-collection-panel]')
      );

      if (!this.tabs.length) return;

      const options = { signal: this.events.signal };

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-collection-tab]');

        if (this.tabs.includes(tab)) {
          this.activateTab(tab);
        }
      }, options);

      this.addEventListener('keydown', (event) => {
        this.onKeyDown(event);
      }, options);

      this.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find(
          (item) => item.dataset.blockId === event.detail?.blockId
        );

        if (tab) {
          this.activateTab(tab);
        }
      }, options);

      const initialTab = this.tabs.find(
        (tab) => tab.getAttribute('aria-selected') === 'true'
      );

      this.activateTab(initialTab || this.tabs[0]);
    }

    onKeyDown(event) {
      const tab = event.target.closest('[data-collection-tab]');
      const index = this.tabs.indexOf(tab);

      if (index === -1) return;

      let nextIndex;
      const isRtl = getComputedStyle(this).direction === 'rtl';

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = index + (isRtl ? -1 : 1);
          break;

        case 'ArrowLeft':
          nextIndex = index + (isRtl ? 1 : -1);
          break;

        case 'Home':
          nextIndex = 0;
          break;

        case 'End':
          nextIndex = this.tabs.length - 1;
          break;

        default:
          return;
      }

      event.preventDefault();

      const nextTab = this.tabs[
        (nextIndex + this.tabs.length) % this.tabs.length
      ];

      this.activateTab(nextTab);

      nextTab.focus({ preventScroll: true });
      nextTab.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }

    activateTab(tab) {
      const panel = this.panels.find(
        (item) => item.id === tab.getAttribute('aria-controls')
      );

      if (!panel) return;

      this.tabs.forEach((item) => {
        const selected = item === tab;

        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((item) => {
        item.hidden = item !== panel;
      });

      cancelAnimationFrame(this.refreshFrame);

      this.refreshFrame = requestAnimationFrame(() => {
        // Dawn's slider needs measurements from the now-visible panel.
        panel.querySelectorAll('slider-component').forEach((slider) => {
          if (typeof slider.resetPages === 'function') {
            slider.resetPages();
          }
        });

        this.dispatchEvent(new CustomEvent('collection-tabs:change', {
          bubbles: true,
          detail: {
            blockId: tab.dataset.blockId,
            panel
          }
        }));
      });
    }
  }

  customElements.define(
    'featured-collection-tabs',
    FeaturedCollectionTabs
  );
}